<template>
  <div class="detailWrap" :style="{ padding: isMobile.isMobile ? '0px !important' : '0px 10px 10px 10px' }">
    <div class="detailCon">

      <div class="contentWrap">
        <div class="leftWrap" :style="{ padding: isMobile.isMobile ? '0px !important' : '5px 10px 5px 5px' }">
          <!-- <h5>课程大纲</h5> -->
          <h5>课程大纲</h5>
          <md-content class="md-scrollbar">

            <v-expansion-panels focusable>
              <v-expansion-panel v-for="(item, i) in items[0] && items[0].children && items[0].children" :key="i">
                <v-expansion-panel-header>
                  <v-icon small style="margin-top: -2px;margin-right: 5px;">fas fa-list</v-icon>
                  <span> 第{{ i + 1 }}章 &nbsp;&nbsp;{{ item.name }}</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panel v-for="(itemss, ii) in item.children && item.children" :key="ii">
                    <div class="d-flex justify-space-between align-center pr-3">
                      <p style="margin: 0px; line-height: 36px; height: 36px; font-size: 13px;">
                        任务{{ ii + 1 }}.&nbsp;&nbsp;{{ itemss.name }}
                      </p>
                      <v-btn color="primary" @click="handleNodeClick(itemss)" small>考核启动</v-btn>
                    </div>

                  </v-expansion-panel>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </md-content>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCourseLeft, simulationParams } from '@/api/simulation';
import { ossMultipartUpload } from '@/api/common'
import { mapGetters, mapState } from 'vuex';
import { openUrlWithInputTimeoutHack } from '../Class/arouse'
export default {
  components: {},
  props: {
    routeData: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      courseOutline: [
        {
          oneName: '一、静水救援',
          twoName: '*教学导航',
          threeName: [
            {
              name: '任务1.1 静水救援',
              children: [
                { name: '-知识图谱' },
                { name: '-技能训练' },
                { name: '-任务体验' },
                { name: '-巩固练习' },
                { name: '-实训报告' },
              ],
            },
            {
              name: '任务1.2静水救援',
              children: [
                { name: '-知识图谱' },
                { name: '-技能训练' },
                { name: '-任务体验' },
                { name: '-巩固练习' },
                { name: '-实训报告' },
              ],
            },
          ],
        },
        {
          oneName: '一、急流救援',
          twoName: '*教学导航',
          threeName: [
            {
              name: '任务1.1 静水救援',
              children: [
                { name: '-知识图谱' },
                { name: '-技能训练' },
                { name: '-任务体验' },
                { name: '-巩固练习' },
                { name: '-实训报告' },
              ],
            },
          ],
        },
      ],

      initiallyOpen: ['public'],
      clickTaskId: null,
      tree: [],
      items: [],
    };
  },
  watch: {
    routeData: {
      handler(news) {
        if (this.routeData !== '{}') {
          this.getCourseLeftFn(news.courseId, news._id);
        }
      },
    },
  },
  methods: {
    async handleNodeClick(item) {
      const platform = this.platform;
      const { data } = await simulationParams({
        _id: this.routeData._id,
        platform,
        runtime: process.env.VUE_APP_RUNTIME,
        studyMode: 'exam',
        taskId: item._id,
      })

      const { url, softDownloadUrl } = data
      
      openUrlWithInputTimeoutHack(
        url,
        () => {
          const res = confirm('应用程序未安装,请下载并安装');
          if (res) {
            window.location.href = softDownloadUrl; // window.open会被浏览器拦截,使用window.location.href下载exe
          }
        },
        () => {
          console.log('传输参数', url)
          console.log('已安装，自动唤起');
        }
      );
    },
    handleCastCourseTree(softInfo) {
      const list = softInfo.courseTree ?? []

      return list.map(item => {
        let jsonObj = {}
        try {
          jsonObj = JSON.parse(item.json)
        } catch (error) {
          jsonObj = {}
        }
        return {
          chapterId: item.id,
          chapterName: item.name,
          ...jsonObj,
          taskList: item.children.map(child => {
            let childJsonObj = {}
            try {
              childJsonObj = JSON.parse(child.json)
            } catch (error) {
              childJsonObj = {}
            }
           
            return {
              taskId: child.id,
              taskName: child.name,
              ...childJsonObj
            }
          })
        }
      })
    },

    async getCourseLeftFn(courseId, simulationId) {
      let params = {
        courseId: courseId || this.routeData.courseId || '',
        simulationId: simulationId || this.routeData._id || '',
      };
      if (!courseId && !simulationId) {
        return;
      }
      let items = Object.assign({}, this.routeData);
      let projectArr = [];
      await getCourseLeft(params).then(res => {
        res.data &&
          res.data.forEach(element => {
            projectArr.push(element);
          });

        items.children = [];
        items.children = projectArr;
        projectArr.forEach(item => {
          if (item && item.children) {
            item.children.forEach(items => {
              items._id = items.taskID;
              items.name = items.taskName;
            });
          }
        });
        this.items.push(items);
      });
    },
    getRoute() {
      // courseView //查看    courseEdit 编辑
      let route = null;
      if (this.$route.query && this.$route.query.courseType) {
        route = this.$route.query.courseType;
      }
      return route;
    },
  },
  mounted() { },
  computed: {
    ...mapGetters(['isMobile', 'user']),
    ...mapState({
      platform: state => state.courseAndProject.simulationPlatform
    })
  },
  created() {
    if (this.routeData !== '{}') {
      this.getCourseLeftFn(this.routeData.courseId, this.routeData._id);
    }
    this.getRoute();
  },
};
</script>
<style scoped>
.detailWrap {
  width: 100%;
  height: 660px;
  background: #fff;
  /* border: 1px solid #c8c8c8; */
  padding: 0px 10px 10px 10px;
}

.courseDescribe {
  /* margin-right: 50px;
    margin-left: 50px; */
  height: auto;
  padding: 30px 40px 20px;
  /* border: 1px solid #c8c8c8; */
  font-weight: bold;
  font-size: 14px;
  background-color: #f5f8f4;
}

.teacherSpeck {
  text-align: right;
}

.contentWrap {
  overflow: hidden;
  margin-top: 10px;
  background: #fff;
  width: 100%;
  height: auto;
}

.leftWrap {
  float: left;
  height: auto;
  padding: 5px 10px 5px 5px;
  width: 100%;
  /* min-height: 600px; */
  /* overflow-y: scroll; */
  /* background: gold; */
}

.leftWrap h4 {
  font-weight: bold;
  margin-bottom: 20px;
  color: #5e5e5e;
}

.detailCon {
  /* margin-right: 50px; margin-left: 50px */
}

@media (max-width: 950px) {
  .detailCon {
    margin-right: 0px;
    margin-left: 0px;
  }
}

>>>.v-treeview-node__label {
  font-size: 14px;
}

>>>.v-treeview-node__root {
  height: 25px;
}

/* >>> .v-treeview-node__children{
  height: 25px;
} */

.md-content {
  /* max-width: 400px; */
  max-height: 600px;
  overflow: auto;
}

.taskTree {
  margin-left: 18px;
}

>>>.v-expansion-panel-content__wrap {
  padding: 0px 0px 0px 35px !important;
}

/* >>>.v-expansion-panel-header{
  display: block !important;
} */
>>>.v-expansion-panel-header> :not(.v-expansion-panel-header__icon) {
  flex: none;
}

>>>.v-icon.v-icon {
  display: flex;
}
</style>